
import api from '@/api/proxyWeb/echeanciers'

export default {

    get({ commit }, id) {

        commit('setCurrentEcheancier', null)
        
        return api.get(id)
            .then(echeancier => {
                commit('setCurrentEcheancier', echeancier)
            })
    },

    getAll({ commit, rootState }) {

        commit('setEcheanciers', null)
        
        let params = {
            client_id: rootState.clients.currentId
        }

        const promise = new Promise(resolve => {
        
            Promise.all([
                api.count(params),
                api.list(params)
            ])
            .then( ([ count, echeanciers ]) => {
                commit('setCount', count)
                commit('setEcheanciers', echeanciers)
                resolve(echeanciers)
            })
        })

        return promise
    },

    getNext({ commit, state, rootState }) {

        let params = {
            client_id: rootState.clients.currentId,
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(echeanciers => {
                commit('setNextEcheanciers', echeanciers)
            })
    }  
}